const getSearchProps = (search, id) => {
  return search === null
    ? null
    : {
        id: `${id}-ledger-search-input`,
        placeholder: 'Search',
        onChangeDelay: 500,
        ...search,
      };
};

export default getSearchProps;
